const REACT_AI_API_URL = import.meta.env.VITE_API_AI_SERVER_URL;

// Re-export event names from eventBus for backward compatibility
export { AvatarEvents, avatarEventBus } from './eventBus';

// Convenient aliases for commonly used events
export const AI_INIT_MESSAGGE = 'AI_INIT_MESSAGGE';
export const AI_INIT_MESSAGGE_PROMPT_VI = 'Xin chào! Mình là trợ lý ảo của bạn. Mình có thể giúp gì cho bạn?';
export const AI_INIT_MESSAGGE_PROMPT_EN = 'Hello! I am your virtual assistant. How can I help you?';

export const AI_CONTEXT_CHANGED = 'AI_CONTEXT_CHANGED';
export const AI_REPEATING_MESSAGE = 'AI_REPEATING_MESSAGE';
export const AI_STREAMING_REPEAT_MESSAGE = 'AI_STREAMING_REPEAT_MESSAGE';
export const AI_STREAMING_AUDIO_MESSAGE = 'AI_STREAMING_AUDIO_MESSAGE';
export const AI_REPEATING_MESSAGE_START = 'AI_REPEATING_MESSAGE_START';
export const AI_REPEATING_MESSAGE_STOP = 'AI_REPEATING_MESSAGE_STOP';
export const AI_VOICE_CHANGED = 'AI_VOICE_CHANGED';

export const TTS_URL = `${REACT_AI_API_URL}/speech/tts_openai/`;

export const LIP_SYNC_MESSAGE_START = 'LIP_SYNC_MESSAGE_START';
export const LIP_SYNC_MESSAGE_STOP = 'LIP_SYNC_MESSAGE_STOP';
export const LIP_SYNC_DATA = 'LIP_SYNC_DATA';

// Streaming audio lip sync events
export const LIP_SYNC_STREAMING_AUDIO_START = 'LIP_SYNC_STREAMING_AUDIO_START';
export const LIP_SYNC_STREAMING_AUDIO_STOP = 'LIP_SYNC_STREAMING_AUDIO_STOP';
export const LIP_SYNC_STREAMING_AUDIO_DATA = 'LIP_SYNC_STREAMING_AUDIO_DATA';
